// extracted by mini-css-extract-plugin
export default {"PanelBody":"PanelBody_PanelBody__pdJqi","PanelBody--hasHeader":"PanelBody_PanelBody--hasHeader__PEK4Q"};